import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { parseHttpStatus } from "./apiLogDisplayUtils";

interface HttpStatusChipProps {
  status?: string;
}

function HttpStatusChip({ status }: HttpStatusChipProps) {
  const parsed = parseHttpStatus(status);
  const chipColor =
    parsed.category === "unknown"
      ? "default"
      : parsed.category;

  return (
    <Tooltip title={`HTTP ${parsed.label}`}>
      <Chip
        size="small"
        variant="outlined"
        color={chipColor}
        label={parsed.code != null ? `HTTP ${parsed.code}` : "HTTP —"}
        aria-label={`HTTP status ${parsed.label}`}
        sx={{ height: 24, fontWeight: 600 }}
      />
    </Tooltip>
  );
}

export default HttpStatusChip;
